import React, { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import JobHistory from './JobHistory';
import FileUpload from './FileUpload';

interface FileInfo {
  name: string;
  type: string;
  duration: number;
}

const Dashboard: React.FC = () => {
  const { user, balance } = useAuth();
  const [fileInfo, setFileInfo] = React.useState<FileInfo | null>(null);

  useEffect(() => {
    console.log('Dashboard: User:', user);
    console.log('Dashboard: Balance:', balance);
  }, [user, balance]);

  if (!user) {
    return <div>Loading user data...</div>;
  }

  const fullName = [user.firstname, user.lastname]
    .filter(Boolean)
    .join(' ') || 'Not provided';

  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">Dashboard</h1>
      <div className="bg-white shadow-md rounded-lg p-6 mb-8">
        <h2 className="text-xl font-semibold mb-2">Account Overview</h2>
        <p>
          <strong>Name:</strong> {fullName}
        </p>
        <p>
          <strong>Email:</strong> {user.email}
        </p>
        <p>
          <strong>Current Balance:</strong> £{balance.toFixed(2)}
        </p>
      </div>
      <div className="flex flex-col md:flex-row gap-8">
        <div className="w-full md:w-2/3 bg-white shadow-md rounded-lg p-6">
          <h2 className="text-xl font-semibold mb-4">Recent Job History</h2>
          <JobHistory />
        </div>
        <div className="w-full md:w-1/3 bg-white shadow-md rounded-lg p-6">
          <FileUpload setFileInfo={setFileInfo} />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;